import React, { useEffect, useState } from "react";
import { FONT_COL_CODES, STAGE_COLOR_CODES } from "../../../../constant/colors";

type AppProps = {
  recruitmentTrackerStageCount: any[] | [];
};
const RecruitmentTrackerStageCount = ({
  recruitmentTrackerStageCount,
}: AppProps) => {
  const [rowBox, setStageBox] = useState(false);
  const [archivedBox, setArchivedBox] = useState(true);
  const [applicationBox, setApplicationBox] = useState(true);

  const [blackWhiteBox, setBlackWhiteBox] = useState(true);

  const [wonBox, setWonBox] = useState(true);
  const [progressBox, setProgressBox] = useState(true);
  const [jobBox, setJobBox] = useState(true);
  useEffect(() => {
    const leadStage: any =
      recruitmentTrackerStageCount?.length &&
      recruitmentTrackerStageCount?.map((el: any) => el?._id);
    if (leadStage?.length) {
      const stageBoxPresent: boolean =
        leadStage?.includes("New Application") ||
        leadStage?.includes("Initial Screening") ||
        false;
      if (stageBoxPresent) {
        setStageBox(true);
      } else {
        setStageBox(false);
      }
      const progressBoxPresent: boolean =
        leadStage?.includes("Application Rejected") ||
        leadStage?.includes("Future Consideration") ||
        leadStage?.includes("Offer Rejected") ||
        leadStage?.includes("Over Budget") ||
        leadStage?.includes("Over Qualified") ||
        leadStage?.includes("Postponed") ||
        false;
      if (progressBoxPresent) {
        setProgressBox(true);
      } else {
        setProgressBox(false);
      }

      const blackWhiteBoxPresent: boolean =
        leadStage?.includes("Accepted but Withdrawn") ||
        leadStage?.includes("Application on Hold") ||
        false;
      if (blackWhiteBoxPresent) {
        setBlackWhiteBox(true);
      } else {
        setBlackWhiteBox(false);
      }

      const archivedBoxPresent: boolean =
        leadStage?.includes("Offer Pending") ||
        leadStage?.includes("To Be Reviewed") ||
        false;
      if (archivedBoxPresent) {
        setArchivedBox(true);
      } else {
        setArchivedBox(false);
      }

      const applicationBox: boolean =
        leadStage?.includes("Offer Pending") ||
        leadStage?.includes("To Be Reviewed") ||
        false;
      if (applicationBox) {
        setApplicationBox(true);
      } else {
        setApplicationBox(false);
      }

      const wonBoxPresent: boolean =
        leadStage?.includes("Final Round") ||
        leadStage?.includes("Pay Approval") ||
        leadStage?.includes("Offer Sent") ||
        false;
      if (wonBoxPresent) {
        setWonBox(true);
      } else {
        setWonBox(false);
      }

      const jobBoxPresent: boolean =
        leadStage?.includes("Phone Screening") ||
        leadStage?.includes("Virtual") ||
        leadStage?.includes("First Interview") ||
        leadStage?.includes("Technical Interview") ||
        leadStage?.includes("Interviewing") ||
        false;
      if (jobBoxPresent) {
        setJobBox(true);
      } else {
        setJobBox(false);
      }
    }
  }, [recruitmentTrackerStageCount]);

  const backColor = (name: string) => {
    const lowerCaseName = name;

    let backgroundColor;
    let fontColor;

    if (
      lowerCaseName.startsWith("New Application") ||
      lowerCaseName.startsWith("Initial Screening")
    ) {
      backgroundColor = STAGE_COLOR_CODES[0];
      fontColor = FONT_COL_CODES[0];
    } else if (
      lowerCaseName.startsWith("Application Rejected") ||
      lowerCaseName.startsWith("Future Consideration") ||
      lowerCaseName.startsWith("Offer Rejected") ||
      lowerCaseName.startsWith("Over Budget") ||
      lowerCaseName.startsWith("Over Qualified") ||
      lowerCaseName.startsWith("Postponed")
    ) {
      backgroundColor = STAGE_COLOR_CODES[1];
      fontColor = FONT_COL_CODES[1];
    } else if (
      lowerCaseName.startsWith("Final Round") ||
      lowerCaseName.startsWith("Pay Approval") ||
      lowerCaseName.startsWith("Offer Sent")
    ) {
      backgroundColor = STAGE_COLOR_CODES[2];
      fontColor = FONT_COL_CODES[2];
    } else if (
      lowerCaseName.startsWith("Offer Pending") ||
      lowerCaseName.startsWith("To Be Reviewed")
    ) {
      backgroundColor = STAGE_COLOR_CODES[3];
      fontColor = FONT_COL_CODES[3];
    } else if (
      lowerCaseName.startsWith("Accepted but Withdrawn") ||
      lowerCaseName.startsWith("Application on Hold")
    ) {
      backgroundColor = STAGE_COLOR_CODES[6];
      fontColor = FONT_COL_CODES[6];
    } else if (
      lowerCaseName.startsWith("Phone Screening") ||
      lowerCaseName.startsWith("Virtual") ||
      lowerCaseName.startsWith("First Interview") ||
      lowerCaseName.startsWith("Technical Interview") ||
      lowerCaseName.startsWith("Interviewing")
    ) {
      backgroundColor = STAGE_COLOR_CODES[4];
      fontColor = FONT_COL_CODES[4];
    } else if (
      lowerCaseName.startsWith("6a") ||
      lowerCaseName.startsWith("6b") ||
      lowerCaseName.startsWith("6c") ||
      lowerCaseName.startsWith("6d") ||
      lowerCaseName.startsWith("6e")
    ) {
      backgroundColor = STAGE_COLOR_CODES[5];
      fontColor = FONT_COL_CODES[5];
    } else {
      backgroundColor = STAGE_COLOR_CODES[6];
      fontColor = FONT_COL_CODES[6];
    }

    return {
      backgroundColor,
      fontColor,
    };
  };
  const styleColor = (name: string) => {
    const { backgroundColor, fontColor } = backColor(name);

    return {
      marginTop: "10px",
      padding: "4px 12px",
      color: fontColor,
      background: backgroundColor,
      borderRadius: "16px",
    };
  };

  const blank = () => {
    return {};
  };

  const checkStage = (stageArray: any, value: string) => {
    return stageArray.some((element: any) => element?.stage === value);
  };

  return (
    <>
      {recruitmentTrackerStageCount?.length ? (
        <div className="row d-flex mb-3 ml-3">
          {(rowBox || archivedBox || wonBox) && (
            <div className="col-md-3">
              {rowBox && (
                <div
                  style={{
                    width: "100%",
                    border: "1px solid rgba(191, 203, 225, 0.6)",
                    borderRadius: "4px",
                    padding: "0px 10px 10px 10px",
                  }}
                >
                  {recruitmentTrackerStageCount?.length
                    ? recruitmentTrackerStageCount?.map((el: any) => {
                        const lowerCaseName = el?._id;
                        if (
                          lowerCaseName.startsWith("New Application") ||
                          lowerCaseName.startsWith("Initial Screening")
                        ) {
                          return (
                            <div
                              className="d-flex justify-content-between"
                              style={{ paddingBottom: "10px" }}
                            >
                              <span
                                style={el?._id ? styleColor(el?._id) : blank()}
                              >
                                {el?._id}
                              </span>
                              <span
                                style={{ marginTop: "10px", fontWeight: "600" }}
                              >
                                {el?.count < 10 ? `0${el?.count}` : el?.count}
                              </span>
                            </div>
                          );
                        }
                      })
                    : ""}
                </div>
              )}
              {archivedBox && (
                <div
                  style={{
                    width: "100%",
                    border: "1px solid rgba(191, 203, 225, 0.6)",
                    borderRadius: "4px",
                    marginTop: "10px",
                    padding: "0px 10px 10px 10px",
                    overflow: "auto",
                  }}
                >
                  {recruitmentTrackerStageCount?.length
                    ? recruitmentTrackerStageCount?.map((el: any) => {
                        const lowerCaseName = el?._id;

                        if (
                          lowerCaseName.startsWith("Offer Pending") ||
                          lowerCaseName.startsWith("To Be Reviewed")
                        ) {
                          return (
                            <div
                              className="d-flex justify-content-between"
                              style={{ marginBottom: "10px" }}
                            >
                              <span
                                style={el?._id ? styleColor(el?._id) : blank()}
                              >
                                {el?._id}
                              </span>
                              <span
                                style={{ marginTop: "10px", fontWeight: "600" }}
                              >
                                {el?.count < 10 ? `0${el?.count}` : el?.count}
                              </span>
                            </div>
                          );
                        }
                      })
                    : ""}
                </div>
              )}

              {wonBox && (
                <div
                  style={{
                    width: "100%",
                    border: "1px solid rgba(191, 203, 225, 0.6)",
                    borderRadius: "4px",
                    marginTop: "10px",
                    padding: "0px 10px 10px 10px",
                    overflow: "auto",
                  }}
                >
                  {recruitmentTrackerStageCount?.length
                    ? recruitmentTrackerStageCount?.map((el: any) => {
                        const lowerCaseName = el?._id;

                        if (
                          lowerCaseName.startsWith("Final Round") ||
                          lowerCaseName.startsWith("Pay Approval") ||
                          lowerCaseName.startsWith("Offer Sent")
                        ) {
                          return (
                            <div className="d-flex justify-content-between">
                              <span
                                style={el?._id ? styleColor(el?._id) : blank()}
                              >
                                {el?._id}
                              </span>
                              <span
                                style={{ marginTop: "10px", fontWeight: "600" }}
                              >
                                {el?.count < 10 ? `0${el?.count}` : el?.count}
                              </span>
                            </div>
                          );
                        }
                      })
                    : ""}
                </div>
              )}
            </div>
          )}
          {(progressBox||blackWhiteBox ) && (

        
          <div
            style={{ display: "flex", flexDirection: "column", width: "30%" }}
          >
            {progressBox && (
              <div
                style={{
                  border: "1px solid rgba(191, 203, 225, 0.6)",
                  borderRadius: "4px",
                  overflow: "auto",
                  padding: "0px 10px 10px 10px",
                  height: "230px",
                }}
              >
                {recruitmentTrackerStageCount?.length
                  ? recruitmentTrackerStageCount?.map((el: any) => {
                      const lowerCaseName = el?._id;

                      if (
                        lowerCaseName.startsWith("Application Rejected") ||
                        lowerCaseName.startsWith("Future Consideration") ||
                        lowerCaseName.startsWith("Offer Rejected") ||
                        lowerCaseName.startsWith("Over Budget") ||
                        lowerCaseName.startsWith("Over Qualified") ||
                        lowerCaseName.startsWith("Postponed")
                      ) {
                        return (
                          <div className="d-flex justify-content-between">
                            <span
                              style={el?._id ? styleColor(el?._id) : blank()}
                            >
                              {el?._id}
                            </span>
                            <span
                              style={{ marginTop: "10px", fontWeight: "600" }}
                            >
                              {el?.count < 10 ? `0${el?.count}` : el?.count}
                            </span>
                          </div>
                        );
                      }
                    })
                  : ""}
              </div>
            )}
            {blackWhiteBox && (
              <div
                style={{
                  border: "1px solid rgba(191, 203, 225, 0.6)",
                  borderRadius: "4px",
                  overflow: "auto",
                  padding: "0px 10px 10px 10px",
                  marginTop: "13px",
                  height: "125px",
                }}
              >
                {recruitmentTrackerStageCount?.length
                  ? recruitmentTrackerStageCount?.map((el: any) => {
                      const lowerCaseName = el?._id;

                      if (
                        lowerCaseName.startsWith("Accepted but Withdrawn") ||
                        lowerCaseName.startsWith("Application on Hold")
                      ) {
                        return (
                          <div className="d-flex justify-content-between">
                            <span
                              style={el?._id ? styleColor(el?._id) : blank()}
                            >
                              {el?._id}
                            </span>
                            <span
                              style={{ marginTop: "10px", fontWeight: "600" }}
                            >
                              {el?.count < 10 ? `0${el?.count}` : el?.count}
                            </span>
                          </div>
                        );
                      }
                    })
                  : ""}
              </div>
            )}
          </div>
            )}
          {jobBox && (
            <div
              className="ml-3"
              style={{
                width: "30%",
                border: "1px solid rgba(191, 203, 225, 0.6)",
                borderRadius: "4px",
                padding: "0px 10px 10px 10px",
                overflow: "auto",
                maxHeight: "230px",
              }}
            >
              {recruitmentTrackerStageCount?.length
                ? recruitmentTrackerStageCount?.map((el: any) => {
                    const lowerCaseName = el?._id;

                    if (
                      lowerCaseName.startsWith("Phone Screening") ||
                      lowerCaseName.startsWith("Virtual") ||
                      lowerCaseName.startsWith("First Interview") ||
                      lowerCaseName.startsWith("Technical Interview") ||
                      lowerCaseName.startsWith("Interviewing")
                    ) {
                      return (
                        <div className="d-flex justify-content-between">
                          <span style={el?._id ? styleColor(el?._id) : blank()}>
                            {el?._id}
                          </span>
                          <span
                            style={{ marginTop: "10px",fontWeight: "600" }}
                          >
                            {el?.count < 10 ? `0${el?.count}` : el?.count}
                          </span>
                        </div>
                      );
                    }
                  })
                : ""}
            </div>
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default RecruitmentTrackerStageCount;
